import { createEvent, createStore } from 'effector';

export const showPreloader = createEvent();
export const hidePreloader = createEvent();

export const $preloader = createStore( false )
  .on( showPreloader, ( _, __ ) => true )
  .reset( hidePreloader );
